import {
  getDeviceHealthCountPending,
  getDeviceHealthCountSuccess,
  getDeviceHealthCountError,
} from './index';
import config from '../../oktaConfig';

function getDeviceHealthCount(accessToken) {
  return dispatch => {
    dispatch(getDeviceHealthCountPending());

    fetch(config.resourceServer.insightsApiUrlDeviceHealthCount, {
      mode: 'cors',
      credentials: 'include',
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    })
      .then(response => {
        if (!response.ok) {
          return Promise.reject();
        }
        return response.json();
      })
      .then(data => {
        dispatch(getDeviceHealthCountSuccess(data));
      })
      .catch(err => {
        dispatch(getDeviceHealthCountError(err));
        /* eslint-disable no-console */
        console.error(err);
      });
  };
}

export default getDeviceHealthCount;
